import PrizeLandingPage from 'components/prize-landing-pages/PrizeLandingPage';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import ImageWithContentSection from 'components/prize-landing-pages/ImageWithContentSection';
import React from 'react';
import { scrollToSection } from 'utils/common';
import WinnerContentSection from 'components/prize-landing-pages/WinnerContentSection';
import { NextSeo } from 'next-seo';
import Link from 'next/link';
import HowItWorksAndChoosePlanSection
  from 'components/prize-landing-pages/HowItWorksAndChoosePlanSection';

const WinAVirginGiftCard = () => {
  const imageDirectory = `${ASSET_PREFIX}/images/prize-landing-pages/win-a-virgin-gift-card`;

  const handleScrollToEntryMethodCards = () => {
    scrollToSection('#howItWorksAndChoosePlanSection');
  };

  return (
    <MainLayout paddedMaxWidthContainer={false}>
      <NextSeo
        title="DAYMADE | Win A Virgin Gift Card Worth £100k"
        description="Enter our weekly draw for the chance to win a Virgin gift card worth £100,000"
        canonical="https://www.daymade.co.uk/prizes/details/100k-virgin-gift-card"
        openGraph={{
          title: 'DAYMADE | Win A Virgin Gift Card Worth £100k',
          description: 'Enter our weekly draw for the chance to win a Virgin gift card worth £100,000',
        }}
      />

      <div id="top-of-page" />

      <PrizeLandingPage>
        <img
          src={`${imageDirectory}/hero.png`}
          className='hero'
          alt="Virgin logo against colour-splash background"
        />

        <GreenPageSection additionalClassName='pageTitleGreenSectionContainer'>
          <Subheading Tag='h1' className='pageTitle'>
            Win A Virgin Gift Card<br />
            <span style={{ fontSize: '2em', display: 'block' }}>
              Worth&nbsp;<strong>£100k</strong>
            </span>
          </Subheading>
          <p>
            Enter our weekly draw for the chance to win a Virgin gift card worth £100,000!
          </p>
          <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
            Enter Now
          </RoundedButton>
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', margin: '3em 1em 0', width: '100%', maxWidth: 450 }}>
            <a href='https://uk.trustpilot.com/review/daymade.co.uk' target='_blank' style={{ margin: '0 0 2em 0', width: '35%' }}>
              <img src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`} style={{ width: '100%' }} />
            </a>
            <a href='https://www.veritree.com/' target='_blank' style={{ margin: '0 0 2em 0', width: '50%', display: 'flex', alignItems: 'center', textAlign: 'left', wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
              <img src={`${ASSET_PREFIX}/images/veritree-logo-dark.svg`} style={{ width: '25%', marginRight: '0.5em' }} />
              Plant a tree with every purchase
            </a>
          </div>
        </GreenPageSection>

        <ImageWithContentSection
          subheadingText={<>Could You Be The Next <strong>Winner?</strong></>}
          imageSrc={`${imageDirectory}/secondary1.png`}
          imageAltText="grid of images showing various Virgin Experiences, including hot air balloon, cruise ship, Spitfire fighter-plane, commercial airliner"
        >
          <p>
            The Virgin Gift Card is your passport to the world of Virgin! Whether you're looking to eat out, cruise the high seas or jet off for the holiday of a lifetime, with a Virgin Gift Card in your wallet, you're sorted. It’s your very own VIP card to unlock a range of fantastic Virgin products and services: from a First Class seat or 6 aboard Virgin Atlantic to a private Necker Island vaycay.
          </p>

          <p>
            Explore {''}
            <Link href='https://www.thevirgingiftcard.co.uk'>
              <a>
                this site
              </a>
            </Link>
            {''} for full details and some great ways to enjoy a VIP Virgin lifestyle with your Virgin Gift Card.
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <ImageWithContentSection
          subheadingText={<>What's <strong>Included?</strong></>}
          imageSrc={`${imageDirectory}/secondary2.png`}
          imageAltText="red sun-umbrella on white sand beach"
          reverseDesktopDirection
        >
          <ul style={{ fontWeight: 600 }}>
            <li>
              Virgin gift card credit worth £100,000 to be spent on Virgin brands
            </li>

            <li>
              Can be used across Virgin brands such as Virgin Atlantic, Virgin Experience Days, Necker Island, Virgin Wines, Virgin Holiday Cruises, Virgin Balloon Flights, Virgin Pure and more
            </li>
          </ul>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-1.png`}
          style={{
            width: '100%',
          }}
        />

        <WinnerContentSection
          onCtaClick={handleScrollToEntryMethodCards}
        />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-2.png`}
          style={{
            width: '100%',
          }}
        />

        <HowItWorksAndChoosePlanSection />
      </PrizeLandingPage>
    </MainLayout>
  );
};

export default WinAVirginGiftCard;
